/**
 * @generated SignedSource<<deacd8d5a7093f974be88606a94d32f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteNavFolderButtonFragment$data = {
  readonly customAppTitle: string | null;
  readonly id: string;
  readonly productApps: {
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "DeleteNavFolderButtonFragment";
};
export type DeleteNavFolderButtonFragment$key = {
  readonly " $data"?: DeleteNavFolderButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteNavFolderButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteNavFolderButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customAppTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "productApps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "50d27c9d1016f5a0850ccc764b00f24c";

export default node;
